export const LOGIN_PATH = '/login';
export const BASE_PATH = '/';
export const ALCOHOL_PATH = '/alcohol';
export const ATTANDANCE_PATH = '/attendance';
export const DRIVER_PATH = '/driver';
export const VEHICLE_PATH = '/vehicle';
export const VEHICLE_ID_PATH = '/vehicle/:id';
export const VEHICLE_USER_ID_PATH = '/vehicle/user/:id';
export const DEVICE_PATH = '/device';
export const CLIENT_PATH = '/client';
export const CLIENT_PATH_ADD = '/client/add';
export const CLIENT_ID_PATH_EDIT = '/client/:id/edit';
export const CLIENT_ID_PATH_VIEW = '/client/:id/view';
export const Driver_ID_PATH = '/driver/:id';
export const DRIVER_HEALTHCHECK_DETAIL = '/driver/healthcheck/:id';